(() => {
  // app/scripts/citations-section.js
  var CitationsSection = class extends HTMLElement {
    constructor() {
      super();
      this.bioz = this.querySelector(".bioz-w-pb");
      this.heading = this.querySelector(".section-heading");
      this.content = this.querySelector(".section-content");
    }
    connectedCallback() {
      this.heading.addEventListener("click", () => {
        this.content.classList.toggle("active");
      });
      const section = this;
      const bioz = this.bioz;
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
          if (bioz.style.display == "none") {
            section.style.display = "none";
          } else {
            section.style.display = "";
            observer.disconnect();
          }
        });
      });
      observer.observe(bioz, { attributes: true, attributeFilter: ["style"] });
    }
  };
  !customElements.get("citations-section") && customElements.define("citations-section", CitationsSection);
})();
